import { FadeIn } from "./FadeIn";
import { BadgePercent, PhoneCall, Sparkles, MapPin } from "lucide-react";

const BENEFITS = [
  {
    icon: BadgePercent,
    title: "Net & Şeffaf Fiyat",
    desc: "İşe başlamadan fiyatı konuşuruz. İş bitince sürpriz ek ücretle karşılaşmazsınız.",
  },
  {
    icon: PhoneCall,
    title: "Direkt Usta İle Görüşme",
    desc: "Aracı firma yok, çağrı merkezi yok. Telefonu doğrudan işi yapacak Beylikdüzü ustası açar.",
  },
  {
    icon: Sparkles,
    title: "Temiz & Titiz Çalışma",
    desc: "Ev ve iş yerinizde kırma dökme yapmadan, iş bittiğinde ortamı temiz bırakarak teslimat yapıyoruz.",
  },
  {
    icon: MapPin,
    title: "Beylikdüzü Yerel Hızlı Servis",
    desc: "Yakın lokasyonda olduğumuz için acil durumlarda kısa sürede kapınızdayız.",
  },
];

export const WhyUs = () => (
  <section id="neden-biz" data-testid="why-section" className="relative py-24 sm:py-32 bg-[#0A0F18] border-y border-slate-800/70">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 mb-4">
          Neden Biz
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 max-w-2xl leading-tight">
          Neden bizi <span className="text-slate-500">tercih etmelisiniz?</span>
        </h2>
      </FadeIn>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {BENEFITS.map(({ icon: Icon, title, desc }, i) => (
          <FadeIn key={title} delay={i * 0.08}>
            <div
              data-testid={`benefit-card-${i}`}
              className="group h-full rounded-3xl border border-slate-800 bg-[#0F172A] p-7 hover:border-amber-500/40 hover:-translate-y-1 transition-all duration-300"
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-amber-500/10 border border-amber-500/30 text-amber-400 mb-6 group-hover:bg-amber-500 group-hover:text-black transition-colors duration-300">
                <Icon className="w-5 h-5" strokeWidth={2.25} />
              </span>
              <h3 className="font-display font-bold text-lg text-slate-50 tracking-tight">{title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
